import React from "react";
import { TextField } from "@mui/material";
import SC from "./style";
const NumberInput = ({
  value = "",
  onChange,
  disableOutline,
  hideSpinButtons,
  ...props
}) => {
  const defaultStyles = {
    width: "20px",
    boxSizing: "border-box",
  };

  const outlineStyles = disableOutline
    ? {
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
      }
    : {};

  const spinButtonStyles = hideSpinButtons
    ? {
        "& input[type=number]": {
          MozAppearance: "textfield",
        },
        "& input[type=number]::-webkit-outer-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
        "& input[type=number]::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
      }
    : {};

  return (
    <>
      {SC.GlobalStyles}
      <TextField
        type="number"
        value={value}
        size="small"
        onChange={(e) => onChange(Number(e.target.value))}
        {...props}
        sx={{
          ...defaultStyles,
          ...spinButtonStyles,
          ...props.sx,
        }}
        InputProps={{
          sx: {
            ...outlineStyles,
          },
        }}
      />
    </>
  );
};

export default NumberInput;
